import React from "react";
import {ResultsPager} from "../../../../Components/Grid";
import {BraillerHistoryRow} from "./BraillerHistoryRow";
import {BraillerRepairDetailsModal} from "./BraillerRepairDetailsModal";
import {useAppContext} from "../../../../Components/StateManager/Context/AppContext";
import {useBraillerRepairDetails} from "../Shared/useBraillerRepairDetails";

interface BraillerHistoryViewProps {
    handleSetSearchCriteria: (criteria: Record<string, any>) => void;
    loanHistories: Record<string, any>[];
    searchCriteria: Record<string, any>;
    totalRecords: number;
    onExportClick?: () => void;
}

export const BraillerHistoryView = ({
                                        handleSetSearchCriteria,
                                        loanHistories,
                                        searchCriteria,
                                        totalRecords
                                    }: BraillerHistoryViewProps) => {

    const {handleApiCall} = useAppContext();
    
    // Use the reusable hook for repair details modal
    const {
        isModalOpen,
        braillerLoanId,
        braillerRepairId,
        showRepairDetails,
        closeRepairDetails
    } = useBraillerRepairDetails(handleApiCall);

    const handleOrderClick = (event: React.MouseEvent<HTMLElement>) => {
        const criteria = {...searchCriteria};
        const columnId = (event.target as HTMLElement).dataset.id;
        criteria.UpdateSorting(columnId);
        handleSetSearchCriteria(criteria);
    };

    const handleFirstClick = () => {
        let criteria = {...searchCriteria};
        criteria.page = 1;
        handleSetSearchCriteria(criteria);
    };

    const handlePreviousClick = () => {
        let criteria = {...searchCriteria};
        if (criteria.page > 1)
            criteria.page = criteria.page - 1;
        handleSetSearchCriteria(criteria);
    };

    const handleNextClick = () => {
        let criteria = {...searchCriteria};
        let totalPages = Math.ceil(totalRecords / criteria.recordsPerPage);
        if (criteria.page < totalPages)
            criteria.page = criteria.page + 1;
        handleSetSearchCriteria(criteria);
    };

    const handleLastClick = () => {
        let criteria = {...searchCriteria};
        criteria.page = Math.ceil(totalRecords / criteria.recordsPerPage);
        handleSetSearchCriteria(criteria);
    };

    const pager = (isSecondaryPager: boolean) => {
        return <ResultsPager
            handleFirstClick={handleFirstClick}
            handlePreviousClick={handlePreviousClick}
            handleNextClick={handleNextClick}
            handleLastClick={handleLastClick}
            isSecondaryPager={isSecondaryPager}
            totalRecords={totalRecords}
            recordsPerPage={searchCriteria.recordsPerPage}
            currentPage={searchCriteria.page}
        />;
    };

    return (
        <>
            {pager(false)}
            <table className="searchResults">
                <thead>
                <tr>
                    <th onClick={handleOrderClick} className="is-clickable" data-id="model">
                        Model
                    </th>
                    <th onClick={handleOrderClick} className="is-clickable" data-id="catalogItemTitle">
                        Title
                    </th>
                    <th onClick={handleOrderClick} className="is-clickable" data-id="serialNumber">
                        Serial Number
                    </th>
                    <th onClick={handleOrderClick} className="is-clickable" data-id="shippingLocationName">
                        Shipping Location
                    </th>
                    <th onClick={handleOrderClick} className="is-clickable" data-id="patronName">
                        Patron
                    </th>
                    <th onClick={handleOrderClick} className="is-clickable" data-id="dateCreatedUtc">
                        Date submitted
                    </th>
                    <th onClick={handleOrderClick} className="is-clickable" data-id="checkedOutDate">
                        Date Checked Out
                    </th>
                    <th onClick={handleOrderClick} className="is-clickable" data-id="returnedDate">
                        Date Returned
                    </th>
                    <th onClick={handleOrderClick} className="is-clickable"  data-id="status">Status</th>
                    <th>Actions</th>

                </tr>
                </thead>
                <tbody>
                {loanHistories && loanHistories.length > 0 ? (
                    loanHistories.map((loanHistory: Record<string, any>, index: number) => (
                        <BraillerHistoryRow
                            key={`${loanHistory.braillerLoanId || loanHistory.loanId || 'unknown'}-${index}`}
                            loanHistory={loanHistory}
                            onShowRepairDetails={showRepairDetails}
                        />
                    ))
                ) : (
                    <tr>
                        <td colSpan={10} className="text-center">
                            No loan history found.
                        </td>
                    </tr>
                )}
                </tbody>
            </table>
            {pager(true)}

            <BraillerRepairDetailsModal
                braillerLoanId={braillerLoanId}
                braillerRepairId={braillerRepairId}
                isOpen={isModalOpen}
                onClose={closeRepairDetails}
                handleApiCall={handleApiCall}
            />
        </>
    );
};

